import { Dialog, DialogContent, Button  } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../Components/CustomSnackbar';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import React, {useState, useEffect}from 'react';
import { CONST_CANTON, FOB_FLAG, iconPassiveNode, PASSIVE_NODE, PON_BOX_FLAG } from '../../Constants/ConstantsOptics';
import { SERVICE_HOUSE_URL, GET_KTV_AMPLIFIER_OP_PASSIVE_NODE_API_URL, GET_PON_BOX_CANTON_PASSIVE_NODE_API_URL, GET_DIVIDER_PASSIVE_NODE_API_URL, GET_CASSETTE_PASSIVE_NODE_API_URL } from '../../OpticApiConfig';
import { ROLE_ADMIN } from '../../Constants/ConstantsOptics';
import axios from 'axios';
import {  fetchPassiveNodeFileCount } from '../DialogDescriptionComponent/CountFile/FileCount';
import FobNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/FobNodeCantonEditingDialog';
import PonBoxNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/PonBoxNodeCantonEditingDialog';
import AmplifierNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/AmplifierNodeCantonEditingDialog';
import OpNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/OpNodeCantonEditingDialog';
import DiviredNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/DiviredNodeCantonEditingDialog';
import CassetteNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/CassetteNodeCantonEditingDialog';
import { UpdateHidEntrancePassiveNode } from '../../WriteData/WriteConnectionComponents';
import { UpdatePassiveNodeDescription } from '../../UpdateData/UpdateCommunications';
import KtvEditingDialogPassiveNode from './DialogEditingNode/KtvEditingDialogPassiveNode';
import PonBoxEditingDialogPassiveNode from './DialogEditingNode/PonBoxEditingDialogPassiveNode';
import { UpdateStatusComponents } from '../../UpdateData/UpdateStatusComponent';
import DialogPassiveNodeFotoEditing from './DialogPassiveNodeFotoEditing';



const DialogPassiveNodeDescroption = ({openModalNode, handleCloseModal, content, user, cantonRefresh,  role, flag, cantonPassiveNodeRefresh, cantonPonBoxRefresh, cantonFobRefresh, setIsComponentChangeCoorPassiveNode}) => {


      const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

      const [openModalEditingPassive, setOpenModalDescriptionPassive] = useState(false);
      const [openModalEditingActivKtv, setOpenModalDescriptionActivKtv] = useState(false);
      const [data, setData] = useState([]);
      const [dataKtvAmplifier, setDataKtvAmplifier] = useState([]);
      const [dataDivider, setDataDivider] = useState([]);
      const [fileCount, setFileCount] = useState(0);
      const [openModalFoto, setOpenModalFoto] = useState(false);
      const [openModalFob, setOpenModalFob] = useState(false);
      const [fobData, setFobData] = useState([]);
      const [openModalPonBox, setOpenModalPonBox] = useState(false);
      const [ponBoxData, setPonBoxData] = useState([]);

      const [openModalAmplifier, setOpenModalAmplifier] = useState(false);
      const [openModalOp, setOpenModalOp] = useState(false);
      const [amplifierData, setAmplifierData] = useState([]);
      const [opData, setOpData] = useState([]);
      const [dividerData, setDividerData] = useState([]);
      const [openModalDivider, setOpenModalDivider] = useState(false);

      const [dataCassette, setDataCassette] = useState([]);
      const [cassetteData, setCassetteData] = useState([]);
      const [openModalCassette, setOpenModalCassette] = useState(false);
      const [houseId, setHouseId] = useState('');
      const [entrance, setEntrance] = useState('');
      const [updatedDescription, setUpdatedDescription] = useState();
      const [isEditingDescription, setIsEditingDescription] = useState(false);

      const copyToClipboard = (text, type) => {
        const textarea = document.createElement("textarea");
        textarea.value = text; 
        textarea.style.position = "absolute"; 
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);

        textarea.select();
        textarea.focus(); 
    
        try {
            const successful = document.execCommand("copy");
            if (successful) {
               
                showSnackbar('Скопировано: ' + type + ' ID: ' + text, 'snackbarOk');
            } else {
                console.log('Copy failed');
                showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
            }
        } catch (err) {
            console.error('Copy error:', err);
            showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
        }
    
        document.body.removeChild(textarea);
    };
    

      const fetchPonBoxLocationNode = async (nodeId) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_PON_BOX_CANTON_PASSIVE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              nodeId,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове GetPonBoxLocationNode:', error);
          throw error;
        }
      }

      const openModalFotoFile = () => {     
          setOpenModalFoto(true);
       }; 

    useEffect(() => {
  const fetchData = async () => {
    try {
      const [ktvAmplifierData, ponBoxData, dividerData, cassetteData] = await Promise.all([
        fetchKtvAmplifierPassiveNode(content.id),
        fetchPonBoxLocationNode(content.id),
        fetchDividerNode(content.id),
        fetchCassetteNode(content.id),
      ]);

      if (ktvAmplifierData) setDataKtvAmplifier(ktvAmplifierData);
      if (ponBoxData) setData(ponBoxData);
      if (dividerData) setDataDivider(dividerData);
      if (cassetteData) setDataCassette(cassetteData);
    } catch (err) {
      console.error(err);
    }
  };

  if (content?.id) {
    fetchData();
  }
}, [
  content?.id, 
  openModalEditingActivKtv,
  openModalEditingPassive,
  openModalAmplifier,
  openModalOp,
  openModalPonBox,
  openModalFob,
  openModalDivider,
  openModalCassette,
]);

       useEffect(() => {
         const updateFileCount = async () => {  
           const count = await fetchPassiveNodeFileCount(content.id);
           if (count !== null) {
             setFileCount(count); 
           }
         };
         updateFileCount();
       });

      const fetchKtvAmplifierPassiveNode = async (nodeId) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_KTV_AMPLIFIER_OP_PASSIVE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              nodeId,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове GetPonBoxLocationNode:', error);
          throw error;
        }
      }

      const fetchDividerNode = async (nodeId) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_DIVIDER_PASSIVE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              nodeId,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове DividerNode:', error);
          throw error;
        }
      }

      const fetchCassetteNode = async (nodeId) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_CASSETTE_PASSIVE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              nodeId,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове DividerNode:', error);
          throw error;
        }
      }

    const openDialogEditingPassive = () => {
      if (!openModalEditingPassive) {
        setOpenModalDescriptionPassive(true);    
      }
    };

    const openDialogEditingActivKtv = () => {
      if (!openModalEditingActivKtv) {
        setOpenModalDescriptionActivKtv(true);
         
      }
    };

    const handleClick = (item) => {
      if (item.fobId && user === item.authorId) {
        setFobData(item);
        setOpenModalFob(true);
      } else if (item.ponBoxId && user === item.authorId) {
        setPonBoxData(item);
        setOpenModalPonBox(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickKtv = (item) => {
      if (item.ktvAmplifierId && (content.authorId === user || ROLE_ADMIN ===  role.role)) {
        setAmplifierData(item);
        setOpenModalAmplifier(true);
      } else if (item.opticalReceiverId && (content.authorId === user || ROLE_ADMIN ===  role.role)) {
        setOpData(item);
        setOpenModalOp(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickDivider = (item) => {
      if (item.dividerId && (content.authorId === user || ROLE_ADMIN ===  role.role)) {
        setDividerData(item);
        setOpenModalDivider(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickCassette = (item) => {
      if (item.cassetteId && (content.authorId === user || ROLE_ADMIN ===  role.role)) {
        setCassetteData(item);
        setOpenModalCassette(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleChangeCoor= (event) => {
      handleCloseDialogs();
      setIsComponentChangeCoorPassiveNode(true);
    }

 

   



useEffect(() => {
  if (isEditingDescription) {
    setUpdatedDescription(prev => prev ?? content.description ?? '');
  }
}, [isEditingDescription]);

 const handleEditDescriptionClick = () => {
  setIsEditingDescription(prev => !prev);
};

 const updateDescriptionPassiveNode = () => {
      UpdatePassiveNodeDescription(content.id, updatedDescription, showSnackbar, user, cantonPassiveNodeRefresh, setIsEditingDescription);
  };

const handleSave = () => {
   if (!houseId || !entrance || houseId.trim() === '' || entrance.trim() === '' || houseId === '0' || entrance === '0') {
    showSnackbar('заполните оба поля и убедитесь, что значения не равны 0', 'snackbarOk');
    return;
  }
  UpdateHidEntrancePassiveNode(content.id, houseId, entrance, showSnackbar, cantonPassiveNodeRefresh, user, handleCloseDialogs);
};


const handleCloseDialogs = () => {
 // cantonPassiveNodeRefresh();
  setHouseId('');
  setEntrance('');
  setUpdatedDescription();
  setIsEditingDescription(false);
  handleCloseModal();
};


const handleDeletePassiveNode = () => {
  if (
    (dataCassette?.length ?? 0) !== 0 ||
    (dataDivider?.length ?? 0) !== 0 ||
    (data?.length ?? 0) !== 0 ||
    (dataKtvAmplifier?.length ?? 0) !== 0 ||
    (dataKtvAmplifier?.length ?? 0) !== 0  ||
    fileCount != 0
  ) {
    showSnackbar('Ошибка! Удалите сначала Активка КТВ/Пассивка', 'snackbarOk');
  } else {
     UpdateStatusComponents(PASSIVE_NODE, content.id, showSnackbar, user, cantonPassiveNodeRefresh, handleCloseDialogs );

  }
};


  return (
    <Dialog 
      open={openModalNode} 
      onClose={handleCloseDialogs}
      className="dialogNodeStyle"
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      PaperProps={{
        elevation: 0,
        style: {
          marginTop: "100px",
          width: '60%',
          height: 'auto',
          maxWidth: '60%',
          maxHeight: 'auto',
        },
      }}
    >
      <DialogContent onClose>
        <div style={{ display: 'flex', flexDirection: 'column' }}>

          {/* Адрес */}
          <div className='custom-node-addres'>
              {/* Левый блок с основной информацией */}
              {content.hid === null ? (
                <div>
                  {content.authorId === user && ( 
                    <>
                    <div>
                    <label style={{ fontWeight: 'bold',  animation: 'blink-red 1s infinite' }}>Закрепите узел</label>
                    <br/>
                  
                    <input
                      className='textInputEditingModal'
                      type="number"
                      value={houseId}
                      placeholder='ID дома'
                      onChange={(e) => setHouseId(e.target.value)}
                      style={{ margin: '2px 0',height:'30px', width: '50%' }}
                    />
                  </div>
                  <div>
                    <input
                      className='textInputEditingModal'
                      type="number"
                      value={entrance}
                      placeholder='подъезд'
                      onChange={(e) => setEntrance(e.target.value)}
                      style={{ margin: '2px 0', height:'30px', width: '50%' }}
                    />
                  </div>
                  <button class='buttonIsSaveDialog2' style={{ margin: '2px 0', textShadow:'black', color:'white', width: '50%' }} onClick={handleSave}>Сохранить</button>
                  </>
                  )}
                </div>
                
                  ) : (
                    <div>
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        <a
                          href={`${SERVICE_HOUSE_URL}?Id=${content.hid}`}
                          target="_blank"
                          style={{ fontWeight: 'bold', color: 'black' }}
                        >
                          {content.street}, дом. {content.numberHouse}
                        </a>
                      </span>
                      <br />
                      <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                        Подъезд:
                        <span style={{ color: '#fcc205', fontWeight: 'normal' }}> {content.entrance}</span>
                      </span>
                      <br />
                      <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                        ID:
                        <span style={{ color: '#fcc205', fontWeight: 'normal' }}> {content.id}</span>
                      </span>
                      <Button
                        style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      >
                        <FileCopyIcon style={{ color: '#e4c253' }} />
                      </Button>
                    </div>
                  )}
                          

              {/* Правый блок с кнопками */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                
                <img
                    src={iconPassiveNode.options.iconUrl}
                    alt="Passive Node"
                    style={{ width: '22px', height: '22px', objectFit: 'contain' }}
                  />

               {content.hid != null && (
                <button className="buttonIsConnectionHouseDialog" onClick={openModalFotoFile}  style={{ marginTop: '5px', color:"white" }}>
                  Фото узла 
                  <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
                      {fileCount > 0 ? fileCount : 'нет'}
                  </span>
                </button>
                
               )}
              </div>
  
          </div>


          <div style={{ display: 'flex', marginTop: '5px' }}>
              {/* Коммент */}
             <div className='dialog-section-nide'>
              <h3 style={{ fontWeight: 'bold', fontSize: '16px', display: 'flex', alignItems: 'center' }}>
                Коммент:
                {(content.authorId === user && content.hid != null) && (
                  <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={handleEditDescriptionClick}>
                    <ModeEditIcon style={{ color: '#e4c253' }} />
                  </Button>
                
                )}
              </h3>
      

              <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />

              {isEditingDescription ? (
                <>
                  <textarea
                  className='areaDescriptionDrawer'
                    value={updatedDescription ?? ''}
                    onChange={(e) => setUpdatedDescription(e.target.value)}
                    style={{ width: '100%', minHeight: '60px', marginBottom: '8px' }}
                  />
                  <button class='buttonIsSaveDialog2' style={{ margin: '2px 0', textShadow:'black', color:'white', width: '50%' }} onClick={updateDescriptionPassiveNode}>Сохранить</button>
                </>
              ) : (
                <div 
                style={{
                    border: '1px solid #f7be4c',
                    borderRadius: '8px', 
                    background: '#a0a0a0',
                    boxShadow: '0px 4px 8px rgb(12, 12, 12)' ,
                    padding: '8px', 
                  }}
                >
                  <label
                      style={{
                        fontSize: '14px',
                        width: '100%',
                        minHeight: '60px',
                        marginBottom: '8px',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'pre-wrap',  
                      }}
                    >
                    {updatedDescription?.trim()
                    ? updatedDescription
                    : content.description?.trim()
                    ? content.description
                    : 'пусто'}
                  </label>
               </div>
             )}
        </div>



              {/* Активка КТВ */}
              <div className='dialog-section-nide '>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, marginRight: '10px' }}>Активка КТВ({dataKtvAmplifier.length} шт.)</h3>

                  { (content.hid != null) && (role.role === ROLE_ADMIN || content.authorId === user ) && (flag === CONST_CANTON) && (
                    <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={openDialogEditingActivKtv}>
                        <ModeEditIcon style={{ color: '#e4c253' }} />
                    </Button>
                  )}

                </div>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
               
                {/*отображение усилков\оп*/}
                {dataKtvAmplifier.length > 0 ? dataKtvAmplifier.map((item, idx) => (
                  <div key={idx}  
                 
                    onClick={() => handleClickKtv(item)}
                   >
                   
                    {item.ktvAmplifierId ? (
                      <div  
                      className={
                      item.statusKtvAmplifier === 1
                        ? 'custom-box-telecom-ktv-on'
                        : 'custom-box-telecom-ktv-off'
                    } 
                     style={{ marginBottom: '3px' }} >
                      
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img src="./amplifier.png" width="30" height="30" style={{ marginRight: "5px" }} alt="FOB" />
                          <span>Усилитель</span>

                          {/* 👉 иконка справа */}
                          {item.statusKtvAmplifier === 1  ? (
                            <img
                              src="./on.png"
                              width="30"
                              height="30"
                              style={{ marginLeft: "auto" }}
                              alt="on"
                            />
                          ) : (
                            <img
                              src="./off.png"
                              width="30"
                              height="30"
                              style={{ marginLeft: "auto" }}
                              alt="off"
                            />
                          )}
                      </div>
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                      </div>
                    ) : item.opticalReceiverId ? (
                       <div  
                      className={
                      
                        'custom-box-telecom'
                        
                    } 
                     style={{ marginBottom: '3px' }} >
                        <img src='./op.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                        <span>Оптический приемник</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                      </div>
                    ) : null}
                  </div>
                )) : null}
              </div>


            {/* Пассивка */}
              <div className='dialog-section-nide'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                   <h3 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, marginRight: '10px' }}>Пассивка({data.length + dataDivider.length + dataCassette.length} шт.)</h3>
                   { (content.hid != null) && (role.role === ROLE_ADMIN ||  content.authorId === user) && (flag === CONST_CANTON) && (
                    <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={openDialogEditingPassive}>
                        <ModeEditIcon style={{ color: '#e4c253' }} />
                    </Button>
                  )} 
                </div>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                 {data.length > 0 ? data.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClick(item)}>
                   
                    {item.fobId ? (
                      <>
                        <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} alt="FOB" />
                        <span>{FOB_FLAG}</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.fobLocationId}</span>
                        <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.fobLocationId, FOB_FLAG);
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))'  }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Фоб:</span> <span style={{ fontSize: '12px' }}>  {item.fobName}</span><br />
                      </>
                    ) : item.ponBoxId ? (
                      <>
                     
                        <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                        <span>{PON_BOX_FLAG}</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.ponBoxLocationId}</span>
                        <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.ponBoxLocationId, PON_BOX_FLAG);
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))'  }} />
                        </Button>
                       
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Бокс:</span> <span style={{ fontSize: '12px' }}>  {item.ponBoxName}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Тип прихода:</span> <span style={{ fontSize: '12px' }}>  {item.comingType}</span><br /> 

                         <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Делитель:</span>
                        <div style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', fontWeight: 'normal' }}>
                          <span>{item.dividerModel}</span>
                          {item.divider2Id !== 5 && <span>{item.dividerModel2}</span>}
                        </div>
                      </div>
                      </>
                    ) : null} 

                    {/* Общая информация */}
                     <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Внес:</span> <span style={{ fontSize: '12px' }}>  {item.authorId}</span><br />
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}>  {item.description}</span><br />
                  </div>
                )) : null} 

                {dataDivider.length > 0 ? dataDivider.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClickDivider(item)}>
                   
                    {item.dividerId ? (
                      <>
                         <img 
                            src={item.polishingId === 1 ? "./divider_upc2.png" : "./divider_apc2.png"} 
                            width="30" 
                            height="30" 
                            style={{ marginRight: "5px" }} 
                            alt="Divider"
                          />
                        <span>Делитель</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span>
                         <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.id, "Делитель");
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px' }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Делитель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Затухание:</span> <span style={{ fontSize: '12px' }}>  {item.attenuation} dB</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Признак:</span> 
                        <span style={{ fontSize: '12px' }}>
                          {item.ktvDivider === 1 && item.ponDivider === 1
                            ? ' KTV PON'
                            : item.ktvDivider === 1
                            ? ' KTV'
                            : item.ponDivider === 1
                            ? ' PON'
                            : ' нет'}
                        </span>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}> {item.description}</span><br />
                      </>
                    ) : null} 
                  </div>
                )) : null }

                {dataCassette.length > 0 ? dataCassette.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClickCassette(item)}>
                   
                    {item.cassetteId ? (
                      <>
                         <img 
                            src={"./cassette.png"} 
                            width="35" 
                            height="35" 
                            style={{ marginRight: "5px" }} 
                            alt="Cassette"
                          />
                        <span>Сплайс-кассета</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span>
                         <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px',  filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.id, "Кассета");
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px' }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Кассета:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Max кол. соединений:</span> <span style={{ fontSize: '12px' }}>  {item.maxWelds}</span><br /> 
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}> {item.description}</span><br />
                      </>
                    ) : null} 
                  </div>
                )) : null }
              </div>
            </div>
              

        </div>

        {(role.role === ROLE_ADMIN || content.authorId === user ) && (
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
        <button
          style={{
            marginTop: '5px',
            color: 'white',
            backgroundColor: '#f84c4c',
            border: 'none',
            textShadow: '1px 1px 2px black',
            borderRadius: '8px',           
            boxShadow: '0 4px 8px rgb(0, 0, 0)', 
            padding: '1px 5px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={e => e.currentTarget.style.backgroundColor = '#f58b8b'}
          onMouseOut={e => e.currentTarget.style.backgroundColor = '#f84c4c'}
          onClick={handleDeletePassiveNode}
        >
          Удалить узел
        </button>
        <button 
          style={{
            marginTop: '5px',
            color: 'white',
            backgroundColor: '#c08e03',
            border: 'none',
            textShadow: '1px 1px 2px black',
            borderRadius: '8px',           
            boxShadow: '0 4px 8px rgb(0, 0, 0)', 
            padding: '1px 5px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={e => e.currentTarget.style.backgroundColor = '#ffbd07'}
          onMouseOut={e => e.currentTarget.style.backgroundColor = '#c08e03'}
          onClick={handleChangeCoor}>
           Редактировать на карте
          </button>
        </div>
        )}

      </DialogContent>

    {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      /> 

      {/* Добавление пассивки на узел */}
      <PonBoxEditingDialogPassiveNode
        open={openModalEditingPassive}
        onClose={() => setOpenModalDescriptionPassive(false)}
        latitude={content.latitude}
        longitude={content.longitude}
        canton={content.canton}
        area={content.area}
        user={user}
        cantonRefresh={cantonPassiveNodeRefresh}
        nodeId={content.id}
        hid={content.hid}
        entrance={content.entrance}
      />

      {/* Добавление КТВ (Усилок, ОП) на узел*/}
      <KtvEditingDialogPassiveNode
        open={openModalEditingActivKtv}
        onClose={() => setOpenModalDescriptionActivKtv(false)}
        cantonRefresh={cantonPassiveNodeRefresh}
        nodeId={content.id}
        user={user}
      />

       {/* Modal Foto*/}
       <DialogPassiveNodeFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          nodeId={content.id}
          user={user}  
          role={role.role}  
          authorId={content.authorId} 
      />   

      {/* Карточка фоба (редактирование)*/}
      <FobNodeCantonEditingDialog
        open={openModalFob}
        onClose={() => setOpenModalFob(false)}
        content={fobData}
        user={user}   
        cantonFobRefresh={cantonFobRefresh}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

      {/* Карточка пон-бокса (редактирование)*/}
      <PonBoxNodeCantonEditingDialog 
        open={openModalPonBox}
        onClose={() => setOpenModalPonBox(false)}
        content={ponBoxData}
        user={user}   
        cantonPonBoxRefresh={cantonPonBoxRefresh}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

      {/* Карточка усилителя (редактирование)*/}
      <AmplifierNodeCantonEditingDialog
        open={openModalAmplifier}
        onClose={() => setOpenModalAmplifier(false)}
        content={amplifierData}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

      {/* Карточка Делителя (редактирование)*/}
      <DiviredNodeCantonEditingDialog
        open={openModalDivider}
        onClose={() => setOpenModalDivider(false)}
        content={dividerData}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

       {/* Карточка Кассеты (редактирование)*/}
       <CassetteNodeCantonEditingDialog
        open={openModalCassette}
        onClose={() => setOpenModalCassette(false)}
        content={cassetteData}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

      {/* Карточка ОП (редактирование)*/}
      <OpNodeCantonEditingDialog
        open={openModalOp}
        onClose={() => setOpenModalOp(false)}
        content={opData}
        cantonRefresh={cantonPassiveNodeRefresh}
      />

    </Dialog>
  );
};


export default DialogPassiveNodeDescroption;